module.exports = {"id":"211017","name":"Víctor Rodríguez","rating":"75","photo":"./data/images/photos/3/211017.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["MG","MD","MOC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VictorRodriguez0.json
// module id = 4256
// module chunks = 0